import {FederatedButton, Icon, Label} from 'app/components/authProvider/buttons/sharedStyles';
import React from 'react';
import {COLORS} from '@fupa/fupa-uikit';

const FACEBOOK_COLOR = '#1877F2';

export default function FacebookFederatedButton({disabled = false, onClick}) {
  return (
    <FederatedButton
      disabled={disabled}
      tabIndex='1'
      onClick={onClick}
      color={disabled ? COLORS.lightestGrey : FACEBOOK_COLOR}>
      <Icon src={disabled ? 'facebook-grey.svg' : 'facebook-white.svg'} width={20} height={20} alt='facebook' />
      <Label color={disabled ? COLORS.grey : COLORS.white}>Mit Facebook fortfahren</Label>
    </FederatedButton>
  );
}
